/**
 * The sprite's path data, in its own module.
 *
 * It lived inside `Icon.tsx`, which meant anything else needing the NAME LIST had to
 * duplicate it — and the first attempt at that did exactly what duplicated lists always do:
 * copied 13 of the 39 names, so two thirds of the sprite would have silently fallen back to
 * a default glyph. One list, imported by both the component and the narrowing helper.
 */
export const PATHS = {
  'ic-gauge': 'M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM13.4 10.6 19 5M3 12a9 9 0 0 1 18 0',
  'ic-layers': 'm12 2 9 5-9 5-9-5 9-5ZM3 12l9 5 9-5M3 17l9 5 9-5',
  'ic-tower': 'M8 21h8M12 21V8M6 3l12 12M18 3 6 15M9 8h6',
  'ic-plug': 'M9 2v6M15 2v6M6 8h12v3a6 6 0 0 1-12 0V8ZM12 17v5',
  'ic-shield': 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z',
  'ic-building': 'M4 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16M8 7h1M8 11h1M8 15h1M12 7h1M12 11h1M12 15h1M16 21h4V11h-4M2 21h20',
  'ic-cable': 'M4 4v7a4 4 0 0 0 8 0V4M4 2h4M8 2v2M12 20v-7a4 4 0 0 1 8 0v7M16 22h4M20 22v-2',
  'ic-globe': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z',
  'ic-library': 'M4 3h4v18H4zM10 3h4v18h-4zM17 4l4 16-3 1-4-16z',
  'ic-check2': 'm4 13 4 4L20 5',
  'ic-calc': 'M5 2h14a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1ZM8 6h8M8 11h.01M12 11h.01M16 11h.01M8 15h.01M12 15h.01M16 15h.01M8 19h8',
  'ic-sliders': 'M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0M16 4v4M10 10v4M18 16v4',
  'ic-file': 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6ZM14 2v6h6M9 14h6M9 18h6',
  'ic-sun': 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  'ic-moon': 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z',
  'ic-chevdown': 'm6 9 6 6 6-6',
  'ic-logout': 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  'ic-chevup': 'm18 15-6-6-6 6',
  'ic-chevright': 'm9 18 6-6-6-6',
  'ic-chevleft': 'm15 18-6-6 6-6',
  'ic-search': 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21l-4.3-4.3',
  'ic-download': 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3',
  'ic-x': 'M18 6 6 18M6 6l12 12',
  'ic-plus': 'M12 5v14M5 12h14',
  'ic-bell': 'M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0',
  'ic-check': 'M20 6 9 17l-5-5',
  'ic-alert': 'M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z',
  'ic-info': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 16v-4M12 8h.01',
  'ic-minus': 'M5 12h14',
  'ic-circle': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z',
  'ic-bolt': 'M13 2 3 14h8l-1 8 10-12h-8l1-8Z',
  'ic-print': 'M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6z',
  'ic-activity': 'M22 12h-4l-3 9L9 3l-3 9H2',
  'ic-server': 'M4 4h16v6H4zM4 14h16v6H4zM8 7h.01M8 17h.01',
  'ic-battery': 'M2 7h16v10H2zM22 11v2M6 11v2M10 11v2',
  'ic-zap': 'M13 2 3 14h8l-1 8 10-12h-8l1-8Z',
  'ic-route': 'M6 22a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM18 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM15 5H9a4 4 0 0 0 0 8h6a4 4 0 0 1 0 8H9',
  /* Corner brackets pointing out / in. Reads as full-screen at 13px, where a four-arrow
     glyph turns to mush. */
  'ic-maximize': 'M8 3H5a2 2 0 0 0-2 2v3M16 3h3a2 2 0 0 1 2 2v3M8 21H5a2 2 0 0 1-2-2v-3M16 21h3a2 2 0 0 0 2-2v-3',
  'ic-minimize': 'M3 8V5a2 2 0 0 1 2-2h3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M21 16v3a2 2 0 0 1-2 2h-3',
  'ic-target': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  /* ── the twin studio's editing verbs. Added with the plan editor: an editor with no
     undo glyph asks the operator to read four words where a shape would do. */
  'ic-undo': 'm9 14-5-5 5-5M4 9h10.5a5.5 5.5 0 0 1 0 11H11',
  'ic-redo': 'm15 14 5-5-5-5M20 9H9.5a5.5 5.5 0 0 0 0 11H13',
  'ic-trash': 'M3 6h18M8 6V4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6M10 11v6M14 11v6',
  'ic-rotate': 'M21 12a9 9 0 1 1-2.6-6.4L21 8M21 3v5h-5',
  'ic-copy': 'M9 9h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V10a1 1 0 0 1 1-1ZM5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1',
  'ic-cursor': 'M4 3l6.5 17 2.6-6.9L20 10.5 4 3Z',
  'ic-square': 'M4 4h16v16H4z',
  'ic-door': 'M3 21h18M6 21V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v17M14 12h.01',
  'ic-save': 'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2ZM17 21v-8H7v8M7 3v5h8',
  'ic-grid': 'M3 3h18v18H3zM3 9h18M3 15h18M9 3v18M15 3v18',
  'ic-move': 'M12 2v20M2 12h20M9 5l3-3 3 3M9 19l3 3 3-3M5 9l-3 3 3 3M19 9l3 3-3 3',
  /* ── the cabinet and its sensors. Added with Cratus's cabinet onboarding; drawn after the
     Iconoir set its designs use, redrawn as single stroke paths at this sprite's weight. */
  'ic-cabinet': 'M5 3h14v18H5zM5 12h14M9 7.5h2M9 16.5h2',
  'ic-lock': 'M6 11h12v10H6zM8 11V7a4 4 0 1 1 8 0v4M12 15v2',
  'ic-safe': 'M4 4h16v15H4zM6 19v2M18 19v2M12 14.5a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12 11.5h.01M17 9v5',
  'ic-leaf': 'M5 19C5 10 10 5 19 5c0 9-5 14-14 14ZM5 19l8-8',
  'ic-torch': 'M8 3h8l-1.5 5h-5L8 3ZM9.5 8h5v12a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V8ZM12 12v2',
  'ic-pin': 'M12 21s-7-6.2-7-11a7 7 0 1 1 14 0c0 4.8-7 11-7 11ZM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z',
  'ic-latch': 'M3 9h8v6H3zM11 12h9M18 9.5v5',
  'ic-smoke': 'M4 17c2-2 4 2 6 0s4 2 6 0 4 2 4 2M4 12c2-2 4 2 6 0s4 2 6 0 4 2 4 2M9 7c1.5-1.5 3 1.5 4.5 0s3 1.5 4.5 0',
  'ic-vibration': 'M3 12l3-4 3 8 3-8 3 8 3-8 3 4',
  'ic-thermometer': 'M14 14.8V4a2 2 0 1 0-4 0v10.8a4 4 0 1 0 4 0ZM12 17.5h.01',
  'ic-droplet': 'M12 3s6 6.5 6 11a6 6 0 1 1-12 0c0-4.5 6-11 6-11Z',
  'ic-waves': 'M3 18c2 0 2.5-1.5 4.5-1.5S10 18 12 18s2.5-1.5 4.5-1.5S19 18 21 18M3 13c2 0 2.5-1.5 4.5-1.5S10 13 12 13s2.5-1.5 4.5-1.5S19 13 21 13M8 8l4-4 4 4',
  'ic-filter': 'M4 5h16l-6 7v6l-4 2v-8L4 5Z',
  'ic-fan': 'M12 13.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM12 10.5C11 7 12 4 14.5 4S17 7.5 13.5 11M13.5 12C17 11 20 12 20 14.5s-3.5 2.5-7 -1M12 13.5c1 3.5 0 6.5-2.5 6.5S7 16.5 10.5 13M10.5 12C7 13 4 12 4 9.5S7.5 7 11 10.5',
  'ic-aircon': 'M3 5h18v8H3zM7 9h10M6 17l-1 3M12 17v3M18 17l1 3',
  'ic-upload': 'M12 16V4M7 9l5-5 5 5M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3',
  'ic-image': 'M4 4h16v16H4zM4 15l4-4 4 4 3-3 5 5M15 9h.01',
  'ic-pencil': 'M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z',
  'ic-eye': 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  'ic-eye-off':
    'M3 3l18 18M10.6 10.6a3 3 0 0 0 4.2 4.2M9.9 5.1A10.4 10.4 0 0 1 12 5c6.5 0 10 7 10 7a17.6 17.6 0 0 1-3.2 4.2M6.6 6.6C3.8 8.5 2 12 2 12s3.5 7 10 7a10 10 0 0 0 5.4-1.6',
  'ic-barcode': 'M4 5v14M7 5v14M11 5v14M14 5v14M17 5v14M20 5v14',
  /* The Single Cabinet View's last-packet time. */
  'ic-clock': 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v5l3 2',
  /* The watchlist (Lumen-BE 0095): followed, filled with `.lm-icon-fill`; not followed, outlined. */
  'ic-star': 'M12 2.5l2.94 5.96 6.56.95-4.75 4.63 1.12 6.54L12 17.5l-5.87 3.08 1.12-6.54L2.5 9.41l6.56-.95L12 2.5Z',
  /* Cratus's Home screen (the FESCO design's `home` glyph), the breadcrumb's first crumb. */
  'ic-home': 'M3.5 10.5 12 3.5l8.5 7V20a1 1 0 0 1-1 1H15v-6H9v6H4.5a1 1 0 0 1-1-1v-9.5Z',
  /* The assistant's mark (the design's `arkai` glyph): two four-point sparks. */
  'ic-send': 'M21 3 10.5 13.5M21 3l-6.5 18-4-7.5L3 9.5 21 3Z',
  'ic-spark': 'M11 3.5l1.7 4.6 4.8 1.7-4.8 1.7L11 16.1l-1.7-4.6-4.8-1.7 4.8-1.7L11 3.5ZM18.5 14.5l.7 1.8 1.8.7-1.8.7-.7 1.8-.7-1.8-1.8-.7 1.8-.7.7-1.8Z',
  /* From the FESCO design's set (Cratus Settings): a person, an envelope, a key and a calendar,
     as single paths — this sprite draws one `d` per glyph. */
  'ic-user': 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4.5 20.5a7.5 7.5 0 0 1 15 0',
  'ic-mail': 'M6 5h12a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3ZM4 7.5l8 5.5 8-5.5',
  'ic-key': 'M15.5 13a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9ZM12.3 11.7 3.5 20.5M6.5 17.5l2.5 2.5M8.5 15.5l2 2',
  'ic-calendar': 'M5.5 5h13a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2ZM3.5 10h17M8 3v4M16 3v4',
} as const;

export type IconName = keyof typeof PATHS;
